import React from 'react';
import { Dropdown } from 'react-bootstrap';
import cn from 'classnames';
import styles from '../Dropdown.module.css';

interface DropdownToggleProps {
  selectedItem: string;
  disabled?: boolean;
}

const DropdownToggle: React.FC<DropdownToggleProps> = ({
  selectedItem,
  disabled,
}) => (
  <Dropdown.Toggle
    id="dropdown-basic-button"
    className={cn(styles.customstyle, styles.dropdownToggle)}
    disabled={disabled}
  >
    <span className={styles.dropdownText}>{selectedItem}</span>
    <span className={styles.dropdownCaret}></span>
  </Dropdown.Toggle>
);

export default DropdownToggle;
